import React from "react";
import { Typography } from "@mui/material";
import { s360ConfigService } from "../../../Services/S360Config";
import Dompurify from "dompurify";
// import "./NCXComponents.styles.css";

function CTNWelcomeMessage(props) {
  const { richText, text, id } = props;

  const renderRichText = () => {
    return {
      __html: Dompurify.sanitize(richText, {
        ADD_ATTR: ["target", "rel"],
        FORCE_BODY: true,
      }),
    };
  };

  const welcomeMessageHeading = `Welcome ${
    s360ConfigService.config.companyName ?? ""
  }`;

  return (
    <div className="ctnWelcomeMessage" key={`${id}-ctnWelcomeMessage`}>
      {/* <Typography
        variant="h4"
        fontWeight={800}
        key={`${id}-ctnWelcomeMessageHeading`}
      >
        {welcomeMessageHeading}
      </Typography> */}
      {richText !== "" && richText !== undefined ? (
        <span
          style={{ color: "#55596B", fontSize: "14px" }}
          dangerouslySetInnerHTML={renderRichText()}
          key={`${id}-ctnWelcomeMessageRich`}
        />
      ) : (
        <span
          style={{ color: "#55596B", fontSize: "14px" }}
          key={`${id}-ctnWelcomeMessageSpan`}
        >
          {text}
        </span>
      )}
    </div>
  );
}

export default CTNWelcomeMessage;
